import { FFComposableDeviceAdd } from '../../../customized/fours-fringand-fr/components/ComposableDevice/AddComposableDevice';
import { ToggleComponent } from '../../../featureToggle';
import { ComposableDeviceAdd } from './ComposableDeviceAdd';

export default ToggleComponent(ComposableDeviceAdd, {
  styledComponentsVariants: {
    'fours-fringand-fr': FFComposableDeviceAdd,
  },
});
